/* eslint-disable */
export default {
  _awesome: 'awesome',
  _Sky: 'Sky',
  _Music: 'Music',
  _Smell: 'Smell',
  _not_quite: 'not_quite',
  _Pizza: 'Pizza',
  _title: 'title',
  _I_use_my_hands_to_touch: 'I_use_my_hands_to_touch',
  _I_use_my_ears_to_hear: 'I_use_my_ears_to_hear',
  _nice_one: 'nice_one',
  _I_use_my_tongue_to_taste: 'I_use_my_tongue_to_taste',
  _Hear: 'Hear',
  _I_use_my_nose_to_smell: 'I_use_my_nose_to_smell',
  _Pool: 'Pool',
  _Car: 'Car',
  _We_have_five_senses: 'We_have_five_senses',
  _Candy: 'Candy',
  _Perfume: 'Perfume',
  _Touch: 'Touch',
  _You_know_five_senses: 'You_know_five_senses',
  _I_dont_think_so: 'I_dont_think_so',
  _Garbage: 'Garbage',
  _Taste: 'Taste',
  _Teacher: 'Teacher',
  _Crayon: 'Crayon',
  _I_use_my_eyes_to_see: 'I_use_my_eyes_to_see',
  _Sight: 'Sight',
  _School_bell: 'School_bell',
  _Bunny: 'Bunny',
  _Lets_play_a_game: 'Lets_play_a_game',
}